<template>
    <div class="userLoginWrapper l-login container">
        <div class="card">
            <div class="card-header">ログイン</div>
            <div class="card-body">
                <form
                    :aria-disabled="inProgress"
                    @submit.stop.prevent="submit">
                    <template v-if="$locale.type === 'default'">
                        <div class="text-center">
                            <template v-if="$store.state.configs.basic_logo !== ''">
                                <img
                                    class="l-login__basic-logo"
                                    :src="$store.state.configs.basic_logo">
                            </template>
                            <template v-else>
                                <h5 class="l-login__basic-name">{{ $store.state.configs.basic_name }}</h5>
                                <p class="l-login__text pb-2">オンライン診療サービスにログイン</p>
                            </template>
                        </div>
                    </template>

                    <div class="form-group">
                        <label
                            class="loginFormLabel"
                            for="email">
                            メールアドレス
                        </label>
                        <input
                            v-model="email"
                            id="email"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.email }"
                            name="email"
                            type="email"
                            tabindex="1"
                            required
                            autofocus>
                        <div
                            v-if="errors.email"
                            class="invalid-feedback d-block">
                            {{ errors.email[0] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label
                            for="password"
                            class="loginFormLabel d-flex justify-content-between">
                            <div>パスワード</div>
                            <a
                                class="loginFormTextLink loginFormTextLinkSmall"
                                href="/password/reset">
                                パスワードを忘れた方はこちら
                            </a>
                        </label>
                        <input
                            v-model="password"
                            id="password"
                            type="password"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.password }"
                            name="password"
                            tabindex="2"
                            required>
                    </div>
                    <div class="form-group text-center">
                        <div class="custom-control custom-checkbox">
                            <input
                                v-model="remember"
                                id="remember"
                                name="remember"
                                class="custom-control-input"
                                type="checkbox">
                            <label
                                class="custom-control-label checkboxRemember"
                                for="remember">
                                <span>ログイン状態を記憶する</span>
                            </label>
                        </div>
                    </div>

                    <div class="text-center">
                        <div class="loginButtonWrapper">
                            <button
                                type="submit"
                                class="btn btn-yokumiru-user loginButton mb-0"
                                :disabled="inProgress">
                                ログイン
                            </button>
                        </div>

                        <template v-if="$locale.type === 'consul'">
                            <hr class="divider dividerOr mt-4 mb-4">

                            <div class="loginButtonWrapper">
                                <a
                                    :href="inProgress ? '#' : `/social/oauth/redirect/line${appQuery}`"
                                    class="loginButton loginButtonLine d-flex align-items-center">
                                    <div class="loginButtonImage d-flex align-items-center">
                                        <img src="/images/common/social_login_line.png">
                                    </div>
                                    <div class="loginButtonText">
                                        LINEアカウントでログイン
                                    </div>
                                </a>
                            </div>
                            <div class="loginButtonWrapper">
                                <a
                                    :href="inProgress ? '#' : `/social/oauth/redirect/apple${appQuery}`"
                                    class="loginButton loginButtonApple d-flex align-items-center">
                                    <div class="loginButtonImage d-flex align-items-center">
                                        <img src="/images/common/social_login_apple.svg">
                                    </div>
                                    <div class="loginButtonText">
                                        Appleでサインイン
                                    </div>
                                </a>
                            </div>
                        </template>
                    </div>

                    <template v-if="$locale.type === 'consul'">
                        <div class="text-center">
                            <hr class="divider mt-4 mb-4">
                            <a
                                class="loginFormTextLink"
                                :href="inProgress ? '#' : `/signup${appQueryAsSignup}`">
                                新規会員登録はこちら
                            </a>
                        </div>
                    </template>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import YokumiruHelper from '../../YokumiruHelper'
import constants from '../../constants'

export default {
    props: {
        appQuery: {
            type: String,
            default: '',
        },
        deviceId: {
            type: String,
            default: '',
        },
        authToken: {
            type: String,
            default: '',
        },
    },

    data: function() {
        return {
            helper: YokumiruHelper,
            email: null,
            password: null,
            remember: false,
            inProgress: false,
            errors: {},
        }
    },

    computed: {
        appQueryAsSignup: function () {
            return this.appQuery.replace('is_login=1', 'is_login=0')
        },
    },

    methods: {
        /**
         * ログイン
         */
        submit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            this.errors = {}

            const params = {
                email: this.email,
                password: this.password,
                remember: this.remember,
            }

            if (this.deviceId && this.authToken) {
                params['device_id'] = this.deviceId
                params['auth_token'] = this.authToken
            }

            await axios.post(constants.user.login.endpoint.base, params)
                .then((res) => {
                    // 200 = ログイン成功 | 302 = 既にログイン済み
                    if (res.status === 200 || res.status === 302) {
                        const data = res.data.data

                        if (data.action === 'oauth_completed') {
                            // アプリ版ログイン
                            let query = '?action=oauth_completed'
                            query += `&device_id=${data.device_id}&auth_token=${data.auth_token}`
                            query += `&access_token=${data.access_token}&expires_at=${data.expires_at}`
                            window.location.href = `/deeplink${query}`
                        }
                        else {
                            // Web版ログイン
                            window.location.href = '/home'
                        }
                    }
                    else {
                        // ログイン失敗時のみ処理中フラグを解除
                        this.inProgress = false
                        bus.$emit('alert-danger', 'ログインに失敗しました。しばらく時間を置いて再度お試しください。')
                    }
                })
                .catch(({response}) => {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger')
                        this.errors = response.data.errors
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }

                    // ログイン失敗時のみ処理中フラグを解除
                    this.inProgress = false
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.userLoginWrapper {
    max-width: 540px;
    margin: 0 auto 100px auto;

    @media screen and (max-width: 640px) {
        max-width: 90%;
        margin: 0 auto 60px auto;
    }

    .divider {
        max-width: 320px;
        margin: 0 auto;
    }

    .dividerOr {
        position: relative;
    }

    .dividerOr::after {
        content: 'そのほかの方法でログイン';
        position: absolute;
        width: 180px;
        height: 20px;
        left: 50%;
        top: 0;
        color: #b2b2b2;
        font-size: 13px;
        text-align: center;
        background: #fff;
        transform: translate3d(-50%, -50%, 0);
    }

    .loginFormLabel {
        color: #4d4a4a;
        font-size: 14px;
        margin-bottom: 3px;
    }

    .loginFormTextLink {
        font-size: 14px;
        text-decoration: underline;
    }

    .loginFormTextLink:hover {
        text-decoration: none;
    }

    .loginFormTextLinkSmall {
        font-size: 13px;
    }

    .checkboxRemember {
        cursor: pointer;
    }

    .checkboxRemember span {
        position: relative;
        top: 1px;
        color: #4d4a4a;
        font-size: 13px;
    }

    /**
     * loginButton
     */
    .loginButtonWrapper {
        max-width: 320px;
        margin: 8px auto;
    }

    .loginButton {
        display: block;
        width: 100%;
        height: 40px;
        text-decoration: none;
        border-radius: 4px;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out
    }

    .loginButton:hover {
        text-decoration: none;
    }

    .loginButtonImage {
        margin-left: 8px;
    }

    .loginButtonImage::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: 30px;
        margin-left: 8px;
        background: rgba(0, 0, 0, 0.08);
    }

    .loginButtonImage img {
        width: 34px;
    }

    .loginButtonText {
        padding-left: 28px;
        color: #fff;
        font-size: 14px;
    }

    /**
     * loginButton - LINE
     */
    .loginButtonLine {
        background: #03C755;
    }

    .loginButtonLine:hover {
        background: #0BB34C;
    }

    .loginButtonLine:hover .loginButtonImage::after {
        background: rgba(0, 0, 0, 0.1);
    }

    /**
     * loginButton - Apple
     */
    .loginButtonApple {
        background: #000;
    }

    .loginButtonApple:hover {
        background: #313131;
    }

    .loginButtonApple .loginButtonImage {
        padding-left: 7px;
    }

    .loginButtonApple .loginButtonImage img {
        position: relative;
        top: -1px;
        width: 20px;
    }

    .loginButtonApple .loginButtonImage::after {
        margin-left: 14px;
        background: rgba(255, 255, 255, 0.3);
    }
}
</style>
